// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { AI_CHALLENGE_START_TIME, compareTime } from "@src/utils";
import { useEffect, useState } from "react";

function useAiEscapeRoomOpen() {
  const [showPlayNow, setShowPlayNow] = useState(false);
  const currentDate = new Date();

  const playNowDate = new Date();
  playNowDate.setTime(AI_CHALLENGE_START_TIME);

  useEffect(() => {
    if (compareTime(currentDate, playNowDate)) {
      setShowPlayNow(true);
    }
  }, []);

  return showPlayNow;
}

export default useAiEscapeRoomOpen;
